import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../App";
import { 
  LayoutDashboard, 
  Users, 
  FileText, 
  Send, 
  BarChart3, 
  Settings, 
  LogOut,
  HelpCircle,
  CreditCard,
  Zap
} from "lucide-react";
import { Button } from "./ui/button";

const navItems = [
  { path: "/", icon: LayoutDashboard, label: "Dashboard" },
  { path: "/contacts", icon: Users, label: "Contacts" },
  { path: "/templates", icon: FileText, label: "Templates" },
  { path: "/campaigns", icon: Send, label: "Campaigns" },
  { path: "/sequences", icon: Zap, label: "Sequences" },
  { path: "/analytics", icon: BarChart3, label: "Analytics" },
  { path: "/billing", icon: CreditCard, label: "Billing" },
  { path: "/settings", icon: Settings, label: "Settings" },
  { path: "/help", icon: HelpCircle, label: "How To" },
];

export const Sidebar = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <aside className="fixed left-0 top-0 h-screen w-64 bg-white border-r border-slate-200 flex flex-col" data-testid="sidebar">
      {/* Logo Section */}
      <div className="p-5 border-b border-slate-100">
        <div className="flex items-center gap-3">
          <img 
            src="/logo-white-bg.png" 
            alt="eSay" 
            className="w-14 h-14 object-contain"
          />
          <div>
            <h1 className="font-bold text-xl text-slate-900 tracking-tight">eSay</h1>
            <p className="text-xs text-slate-500">Email Marketing</p>
          </div>
        </div>
      </div>
      
      {/* Navigation */}
      <nav className="flex-1 p-3">
        <ul className="space-y-1">
          {navItems.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                end={item.path === "/"}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all ${
                    isActive
                      ? "bg-sky-50 text-sky-700 border-l-[3px] border-sky-600"
                      : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
                  }`
                }
                data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
              >
                <item.icon className="w-[18px] h-[18px]" />
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Sign Out */}
      <div className="p-3 border-t border-slate-100">
        <Button
          variant="ghost"
          className="w-full justify-start text-slate-600 hover:text-red-600 hover:bg-red-50 font-medium"
          onClick={handleLogout}
          data-testid="logout-button"
        >
          <LogOut className="w-[18px] h-[18px] mr-3" />
          Sign Out
        </Button>
      </div>
    </aside>
  );
};
